import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "os-minus",
  "use": "os-minus-usage",
  "viewBox": "0 0 15.43 0.791",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.43 0.791\" id=\"os-minus\"><path d=\"M.371.791H15.05q.107 0 .195-.049.088-.049.137-.137.049-.087.049-.195 0-.107-.05-.19-.048-.083-.136-.137-.088-.054-.195-.054H.37q-.098 0-.18.054Q.106.137.053.22 0 .303 0 .41q0 .108.054.195.053.088.136.137.083.049.181.049z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol